export default {
  clear ({ commit }) {
    commit('CLEAR_DATA')
  }
}
